import { memo } from 'react';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

function AggregatorRewardsForm({ aggregatorDisableRewards, changeChecked }) {
  return (
    <Col md={6} className="bo-same-line">
      <Form.Check
        name="disableRewards"
        id="disableRewards"
        checked={aggregatorDisableRewards || false}
        onChange={changeChecked}
      />
      <Form.Label className="p-0 m-0">Disable Rewards</Form.Label>
    </Col>
  );
}

export default memo(AggregatorRewardsForm);
